module.exports = __webpack_public_path__ + "img/hewanwen.e08c747e.png";